import React, { useEffect, useState } from 'react';
import { AlertTriangleIcon } from 'lucide-react';
export function Urgency() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section className="w-full px-4 py-16 md:py-20" data-id="element-397">
      <div className="max-w-4xl mx-auto" data-id="element-398">
        <div className="bg-gradient-to-br from-red-500/20 to-orange-500/20 border-2 border-red-500 rounded-2xl p-6 md:p-10" data-id="element-399">
          <div className="flex flex-col items-center justify-center gap-4 mb-8" data-id="element-400">
            <AlertTriangleIcon className="w-8 h-8 text-red-400" data-id="element-401" />
            <h2 className="text-2xl md:text-4xl font-bold text-white text-center leading-tight" data-id="element-402">
              Oferta Limitada — El reloj está corriendo
            </h2>
          </div>
          <div className="flex justify-center gap-2 md:gap-4 mb-8" data-id="element-403">
            <div className="bg-slate-900 rounded-lg p-3 md:p-4 min-w-[80px] md:min-w-[100px] text-center" data-id="element-404">
              <div className="text-3xl md:text-4xl font-bold text-white mb-1" data-id="element-405">
                {String(timeLeft.hours).padStart(2, '0')}
              </div>
              <div className="text-xs md:text-sm text-gray-400" data-id="element-406">HORAS</div>
            </div>
            <div className="flex items-center text-2xl md:text-3xl font-bold text-white" data-id="element-407">
              :
            </div>
            <div className="bg-slate-900 rounded-lg p-3 md:p-4 min-w-[80px] md:min-w-[100px] text-center" data-id="element-408">
              <div className="text-3xl md:text-4xl font-bold text-white mb-1" data-id="element-409">
                {String(timeLeft.minutes).padStart(2, '0')}
              </div>
              <div className="text-xs md:text-sm text-gray-400" data-id="element-410">MINUTOS</div>
            </div>
            <div className="flex items-center text-2xl md:text-3xl font-bold text-white" data-id="element-411">
              :
            </div>
            <div className="bg-slate-900 rounded-lg p-3 md:p-4 min-w-[80px] md:min-w-[100px] text-center" data-id="element-412">
              <div className="text-3xl md:text-4xl font-bold text-white mb-1" data-id="element-413">
                {String(timeLeft.seconds).padStart(2, '0')}
              </div>
              <div className="text-xs md:text-sm text-gray-400" data-id="element-414">SEGUNDOS</div>
            </div>
          </div>
          <div className="space-y-4 text-center" data-id="element-415">
            <p className="text-base md:text-xl text-gray-200" data-id="element-416">
              La IA evoluciona rápido.
            </p>
            <p className="text-base md:text-xl text-gray-200" data-id="element-417">
              Pronto actualizaremos el sistema y subiremos el precio.
            </p>
            <p className="text-sm md:text-lg text-gray-300" data-id="element-418">
              Cuanto antes entres, antes empezarás a crecer mientras otros
              siguen adivinando.
            </p>
          </div>
        </div>
      </div>
    </section>;
}